import { createApiAction } from '@app/packages/api/utils'

export const postEmailSubscriptions = (topic: string, email: string) =>
  createApiAction('postEmailSubscriptions', dispatch =>
    dispatch<unknown>({ method: 'POST', endpoint: '/api/v2/email_subscriptions', body: JSON.stringify({ topic, email }) })
  )
